import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { LARGE_MARGIN, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      '& $headerWrapper': {
        paddingBottom: 0,
      },
    },
    headerWrapper: {},
    breadcrumbsWrapper: {
      marginBottom: MIDDLE_MARGIN,
      [theme.breakpoints.up('md')]: {
        marginBottom: SMALL_MARGIN,
      },
    },
    titleWrapper: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: SMALL_MARGIN,
      [theme.breakpoints.up('md')]: {
        marginBottom: MIDDLE_MARGIN,
      },
    },
    logoWrapper: {
      marginRight: SMALL_MARGIN,
      marginBottom: 0,
      width: 40,
      height: 40,
      [theme.breakpoints.up('md')]: {
        width: 56,
        height: 56,
      },
    },
    title: {
      flex: 1,
    },
    description: {
      maxWidth: 620,
      marginBottom: MIDDLE_MARGIN,
      [theme.breakpoints.up('md')]: {
        marginBottom: 54,
      },
    },
    bottomItemsWrapper: {
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: LARGE_MARGIN,
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingBottom: MIDDLE_MARGIN,
      },
    },
  }),
);

export default useStyles;
